import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import FooterPanel from './../../FooterPanel';
import SifusHeroPanel from "./SifusHeroPanel";
import SifusPanel from "./SifusPanel";
import MerchPanel from "./../../MerchPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class SifusPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    let self = this;
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'instructors'} />
              <SifusHeroPanel />
              <SifusPanel />
              <MerchPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(SifusPage)
